import * as Yup from 'yup';

export const complianceValidator = Yup.mixed()
    .oneOf(['yes', 'no'])
    .required((messageParams: { label: string; path: string }) => `${getFieldName(messageParams)} is required`);
export const complianceSymbolValidator = (complianceValidatorName: string) => {
    return Yup.array()
        .nullable()
        .when(complianceValidatorName, {
            is: (value: string) => value === 'yes',
            then: () =>
                Yup.array()
                    .of(Yup.string())
                    .min(
                        1,
                        (messageParams: { label: string; path: string }) =>
                            `At least one symbol is required if ${getFieldName(messageParams)} is set to yes`,
                    ),
        });
};

const getFieldName = (messageParams: { label: string; path: string }) => {
    if (messageParams.label) {
        return messageParams.label;
    }

    if (messageParams.path) {
        const normalized = messageParams.path
            ?.replace('Symbol', '')
            .replace(/([A-Z])/g, ' $1')
            .toLocaleLowerCase();
        return `${normalized.charAt(0).toUpperCase()}${normalized.slice(1)}`;
    }

    return 'This field';
};
